import { render, staticRenderFns } from "./PaymentTerm.vue?vue&type=template&id=10cb5ce8"
import script from "./PaymentTerm.vue?vue&type=script&lang=js"
export * from "./PaymentTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports